export function dataInRequest(params = {}) {
  return {
    type: '@operacaoLimpezaDvec/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@operacaoLimpezaDvec/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@operacaoLimpezaDvec/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@operacaoLimpezaDvec/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@operacaoLimpezaDvec/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@operacaoLimpezaDvec/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@operacaoLimpezaDvec/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@operacaoLimpezaDvec/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaoLimpezaDvec/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaoLimpezaDvec/RECORD_FILTERING',
    payload: { params },
  };
}
